import React from 'react';
import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import {REASSIGN_SCHEME_TYPES} from '@constants';
import './authTypeSelector.less';

const AuthTypeSelector = ({selectedAuthType, onAuthTypeChange, isEnforcedAuth}) => {
    const intl = useIntl();

    const getAuthTypeLabel = (authType) => {
        switch (authType) {
            case REASSIGN_SCHEME_TYPES.EMAIL:
                return intl.formatMessage({
                    id: 'oss.components.ReassignAuth.authType.none',
                    defaultMessage: 'None (Email only)'
                });
            case REASSIGN_SCHEME_TYPES.QNA:
                return intl.formatMessage({
                    id: 'oss.components.ReassignAuth.authType.qna',
                    defaultMessage: 'Question & Answer'
                });
            case REASSIGN_SCHEME_TYPES.SMS:
                return intl.formatMessage({
                    id: 'oss.components.ReassignAuth.authType.sms',
                    defaultMessage: 'SMS Verification'
                });
            default:
                return '';
        }
    };

    const handleAuthTypeChange = (event) => {
        onAuthTypeChange(event.target.value);
    };

    const getIsAuthTypeDisabled = (authType) => {
        if (!isEnforcedAuth) {
            return false;
        }
        return authType !== isEnforcedAuth.scheme;
    };

    return (
        <FormControl component="fieldset" className="auth-type-selector" data-wdio="test-auth-type-selector">
            <FormLabel component="legend" className="auth-type-selector__label">
                {intl.formatMessage({
                    id: 'oss.components.ReassignAuth.authType.label',
                    defaultMessage: 'Additional Authentication'
                })}
            </FormLabel>
            <RadioGroup
                aria-label={intl.formatMessage({
                    id: 'oss.components.ReassignAuth.authType.ariaLabel',
                    defaultMessage: 'Select authentication type'
                })}
                name="auth-type"
                value={selectedAuthType}
                onChange={handleAuthTypeChange}
                className="auth-type-selector__group"
            >
                <FormControlLabel
                    value={REASSIGN_SCHEME_TYPES.EMAIL}
                    control={<Radio color="primary" data-wdio="test-auth-type-none" />}
                    label={getAuthTypeLabel(REASSIGN_SCHEME_TYPES.EMAIL)}
                    disabled={getIsAuthTypeDisabled(REASSIGN_SCHEME_TYPES.EMAIL)}
                />
                <FormControlLabel
                    value={REASSIGN_SCHEME_TYPES.QNA}
                    control={<Radio color="primary" data-wdio="test-auth-type-qna" />}
                    label={getAuthTypeLabel(REASSIGN_SCHEME_TYPES.QNA)}
                    disabled={getIsAuthTypeDisabled(REASSIGN_SCHEME_TYPES.QNA)}
                />
                <FormControlLabel
                    value={REASSIGN_SCHEME_TYPES.SMS}
                    control={<Radio color="primary" data-wdio="test-auth-type-sms" />}
                    label={getAuthTypeLabel(REASSIGN_SCHEME_TYPES.SMS)}
                    disabled={getIsAuthTypeDisabled(REASSIGN_SCHEME_TYPES.SMS)}
                />
            </RadioGroup>
        </FormControl>
    );
};

AuthTypeSelector.propTypes = {
    selectedAuthType: PropTypes.oneOf([
        REASSIGN_SCHEME_TYPES.EMAIL,
        REASSIGN_SCHEME_TYPES.QNA,
        REASSIGN_SCHEME_TYPES.SMS
    ]).isRequired,
    onAuthTypeChange: PropTypes.func.isRequired,
    isEnforcedAuth: PropTypes.shape({
        scheme: PropTypes.oneOf([
            REASSIGN_SCHEME_TYPES.EMAIL,
            REASSIGN_SCHEME_TYPES.QNA,
            REASSIGN_SCHEME_TYPES.SMS
        ])
    })
};

AuthTypeSelector.defaultProps = {
    isEnforcedAuth: null
};

export default AuthTypeSelector;
